export default __webpack_public_path__ + "static/media/logo-declogues.ce436ac9.jpg";